import React, { Component } from "react";
import { connect } from 'react-redux';
import { getRecentlyInvoicedOrders, submitRecentlyInvoicedOrders } from "redux/actions/invoicing-actions";
import ReactValidator from "simple-react-validator";
import DatePicker from "react-datepicker";
import {
    Grid,
    Row,
    Col,
    OverlayTrigger,
	Tooltip,
    Popover,
    Button
} from "react-bootstrap";
import { Card } from "components/Card/Card.jsx";
import 'react-table/react-table.css';
import { Link } from 'react-router-dom';
import { appendValues, dateFormatMy, hasRole } from 'helper/helperFunctions';
import ReactToPrint from "react-to-print";
import Pagination from "../../ThemeComponents/Pagination";

const moment = window.moment;
var date = moment(new Date()).format("YYYY-MM-DD");

class RecentlyInvoicedOrdersPage extends Component {
    constructor(props) {
        super(props);
        this.dateValidator = new ReactValidator();
        this.state = {
            fromDate: '',
            to: '',
            pageSize: 10,
            page: 0,
            sorted: '',
            selected: {},
            selectAll: 0,
            newdata: [],
            checked:0,
            invoiceDate:date,
            selectedInvoiced: [],
        };
        this.toggleRow = this.toggleRow.bind(this);
        this.renderEditable = this.renderEditable.bind(this);

    }
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.reportsData !== this.props.reportsData) {
            const temp = appendValues(this.props.reportsData, [{ column: 'comments', value: '' }, { column: 'checklist', value: false }]);
            this.setState({
                newdata: temp
            })
            // console.log('updated');
        }
    }



    toggleRow(id) {
        let newdataTemp = [...this.state.newdata];
        newdataTemp[id]['checklist'] = !newdataTemp[id]['checklist']
        // console.log(id,'rowtoggle')
        // console.log("ToggleRow",this.state.checked)
        this.setState({
            newdata: newdataTemp,
            checked:0
        });

        this.checkedcalculator()

    }
    checkedcalculator(){
        this.setState({checked:0})
        var positive = 0
        var negative = 0
        this.state.newdata.map(x => x.checklist ? positive = positive + 1: negative +1)
        this.setState({checked : positive})
    }
    toggleSelectAll() {
        // let newSelected = {};
        let newdataTemp = [...this.state.newdata];
        if (this.state.selectAll === 0) {

            newdataTemp.forEach(x => {
                x['checklist'] = true;
            });
        } else {
            newdataTemp.forEach(x => {
                x['checklist'] = false;
            });
        }

        this.setState({
            newdata: newdataTemp,
            selectAll: this.state.selectAll === 0 ? 1 : 0
        });
        this.checkedcalculator()
    }

    DateChangeHandler = (value, field) => {
        this.setState({ [field]: value === null ? '' : moment(value).format("YYYY-MM-DD") }, () => {
            if (this.dateValidator.allValid()) {
                const { fromDate, to, page, pageSize, sorted } = this.state;
                // this.props.getReportsCall(1, fromDate, to, page, pageSize, sorted);
            } else {
                this.dateValidator.showMessages();
                // this.forceUpdate();
            }
        })
    }
    dateElement(label, name, value, rules) {
        var selectedDate = this.state[name] !== '' ? new Date(this.state[name]) : '';
        return (
            <div className='form-group fullCalendar' id={name}>
                <label>{label}</label>
                <DatePicker className="form-control calender_icon" dateFormat={hasRole(['gm admin']) ? 'dd/MM/yyyy' : 'MM/dd/yyyy'} selected={selectedDate} name={name} onChange={(event) => this.DateChangeHandler(event, name)} />

            </div>
        );
    }
    reportsPaginationData = (page = this.state.page, sorted = this.state.sorted, pageSize = this.state.pageSize) => {
        const { fromDate, to } = this.state;
        this.props.getReportsCall(1, fromDate, to, page, pageSize, sorted);
    }
    changedDate = (x) => {
        this.setState({invoiceDate:x})
    }
    processOrders = (page = this.state.page, sorted = this.state.sorted, pageSize = this.state.pageSize) => {
        let newdataTemp = [...this.state.newdata];
        const { fromDate, to } = this.state;
        let newArray = {};
        newdataTemp.forEach(x => {
            if (x.checklist === true)
                newArray[x.id] = { "order_id": x.id, 'customer_note': x.comments,};
        });
        console.log("invoice", newArray);
        if (Object.keys(newArray).length === 0) {
            alert("Please select the orders to process")
            return
        }
        this.props.submitRecentlyInvoicedOrdersCall(newArray,this.state.invoiceDate).then(
            response => {
                this.pagination.dataCall();
            },
            error => {

            }
        );
        this.checkedcalculator()

    }

    selectedInvoiced = () => {
        let newdataTemp = [...this.state.newdata];
        let newArray = [];
        newdataTemp.forEach(x => {
            if (x.checklist === true)
                newArray.push(x.id);
        });
        if (Object.keys(newArray).length === 0) {
            this.setState({
                selectedInvoiced: []
            })
            alert("Please select the orders to print")
            return
        } else {
            this.setState({
                selectedInvoiced: newArray
            })
        }
    }

    handleInputChange = (cellInfo, event) => {
        let newdata = [...this.state.newdata];
        newdata[cellInfo.index][cellInfo.column.id] = event.target.value;

        this.setState({ newdata });
    };

    getRowProps = (rowInfo) => {
        let data = {}
        if (rowInfo.qbo_last_error !== undefined && rowInfo.qbo_last_error != null) {
            data = {
                color: 'red'
            }
        }
        return data;
    }

    renderEditable = cellInfo => {
        const cellValue = this.state.newdata[cellInfo.index] !== undefined ? this.state.newdata[cellInfo.index][cellInfo.column.id] : null;
        if (cellValue !== null) {
            return (
                <textarea
                    placeholder="-"
                    name="input"
                    onChange={this.handleInputChange.bind(null, cellInfo)}
                    value={cellValue}
                />
            );
        } else {
            return (<span></span>);
        }
    };

    paginationCall = (data) => {
        const { fromDate, to } = this.state;
        return this.props.getReportsCall(1, fromDate, to, data.page, data.pageSize, data.sort)
    }

    render() {
        const { total_amount, total_invoices, total_orders } = this.props;
        const columns = [
            {
                Header: "Recently Invoiced Orders",
                headerClassName: 'headerPagination',
                columns: [
                    {
                        Header: "Bill Cycle",
                        accessor: "order_shipping_items",
                        Cell: ({ value }) => (
                            <div>
                                IMMEDIATE (SHIP)
                            </div>
                        ),
                        className: "action-center",
                        sortable: false,
                    },
                    {
                        Header: "Barcode",
                        accessor: "barcode",
                        width: 200,
                        Cell: ({ value, original }) => {
                            return <Link target="_blank" to={'/Admin/' + original.id + '/order-edit#pricing_details'} className="blue_link">{value}</Link>
                        },
                        className: "action-center",
                        sortable: false,
                    },
                    {
                        Header: "Agency",
                        accessor: "agency_name",
                        className: "action-center",
                        sortable: false,
                    },
                    {
                        Header: "Client",
                        accessor: "group_name",
                        className: "action-center",
                        sortable: false,
                    },
                    {
                        Header: "Invoice File Date",
                        accessor: "quickbooks_synced_at",
                        Cell: ({ value }) => (
                            <div>
                                {dateFormatMy(value)}
                            </div>
                        ),
                        className: "action-center",
                        sortable: false,
                    },
                    {
                        Header: "Departure Date",
                        accessor: "departuredate",
                        Cell: ({ value }) => (
                            <div>
                                {dateFormatMy(value)}
                            </div>
                        ),
                        className: "action-center",
                        sortable: false,
                    },
                    {
                        Header: "Updated",
                        accessor: "modified_at",
                        Cell: ({ value }) => (
                            <div>
                                {dateFormatMy(value)}
                            </div>
                        ),
                        className: "action-center",
                        sortable: false,
                    },
                    {
                        Header: "Total",
                        accessor: "grand_total",
                        className: "action-center",
                        sortable: false,
                    },
                    {
                        Header: "View",
                        accessor: "id",
                        Cell: ({ value, original }) => {
                            return (
                                <>
                                    <Link target="_blank" to={'/Admin/' + original.id + '/order-edit#pricing_details'} className="blue_link">View</Link>
                                    {
                                    original.qbo_last_error && original.qbo_last_error.description &&
                                    <OverlayTrigger placement="right" overlay={<Tooltip id="tooltip">{original.qbo_last_error.description}</Tooltip>}>
                                        <span className="question_mark">?</span>
                                    </OverlayTrigger>
                                    }
                                </>
                            )
                        },
                        className: "action-center",
                        sortable: false,
                    },
                    {
                        Header: "Comments",
                        accessor: "adminComment",
                        Cell: this.renderEditable,
                        sortable: false,
                        width: 250
                    },
                    // {
                    //     accessor: "checklist",
                    //     Cell: ({ original, row }) => {
                    //         return (
                    //             <input
                    //                 style={{ width: "30", height: "30"}}
                    //                 type="checkbox"
                    //                 className="checkbox"
                    //                 onChange={() => this.toggleRow(row._index)}
                    //                 checked={original.checklist}
                    //             />
                    //         );
                    //     },
                    //     Header: x => {
                    //         return (
                    //             <input
                    //                 style={{ width: "30", height: "30"}}
                    //                 type="checkbox"
                    //                 className="checkbox"
                    //                 checked={this.state.selectAll === 1}
                    //                 ref={input => {
                    //                     if (input) {
                    //                         input.indeterminate = this.state.selectAll === 2;
                    //                     }
                    //                 }}
                    //                 onChange={() => this.toggleSelectAll()}
                    //             />
                    //         );
                    //     },
                    //     sortable: false,
                    //     width: 45
                    // },
                ]
            }
        ];
        return (
            <div className="content">


                <Grid fluid>
                    <Row>
                        <Col md={12}>
                            <Card
                                ctTableResponsive
                                content={
                                    <div>
                                        <Grid fluid>
                                            <div className="row"  >
                                                <Col md={12} >
                                                    <div className="secHeading">Recently Invoiced Orders In Last 7 Days</div>
                                                </Col>

                                                <Col md={6} style={{lineHeight:"38px"}}>
                                                {
                                                    total_amount !== undefined &&
                                                    <>
                                                        <div><strong> Invoices: </strong>({total_invoices}):
                                                        ${total_amount.toFixed(2)}
                                                            <strong> Orders Listed: </strong> {total_orders}
                                                            {/* <strong> Orders Selected: </strong> {this.state.checked} */}
                                                            </div>
                                                        <div>
                                                            <span style={{color: "red", fontWeight:"bold"}}>Red</span> color shows Quickbooks error
                                                        </div>
                                                    </>
                                                }
                                                </Col>
                                                {/* <Col md={6}  >

                                                    <div className='row flexElem flexResponsive align-items-center' >
                                                        <div className="col-md-5" >
                                                            <div >
                                                                <OverlayTrigger placement="bottom" trigger={['hover']} overlay={<Popover id="tooltip">Send Orders to Invoices</Popover>}>
                                                                    <Button type='button' className="backButton pt-sm no_radius btn-block pb-sm primary mt-none btn btn btn-info " onClick={this.processOrders} ><i className="fa fa-gear" />Un-Process Invoices</Button>
                                                                </OverlayTrigger>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Col> */}

                                                <Pagination
                                                    ref={(p) => this.pagination = p}
                                                    showPagination={false}
                                                    columns={columns}
                                                    noDataText='No order found'
                                                    pageSize={10}
                                                    getDataCall={this.paginationCall}
                                                    filterView={false}
                                                    // downloadData={true}
                                                    // downloadFileName={'Orders'}
                                                    // lowerContent = {null}
                                                    // filterPlaceHolder = {'Orders'}
                                                    getRowProps={this.getRowProps}
                                                // showAllToggle={true}
                                                />
                                            </div>
                                        </Grid>
                                    </div>
                                } />
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => {
    // console.log(invoiceDate,"invooic date send in dispatch")
    return ({
        getReportsCall: (value, fromDate, toDate, page, pageSize, sorted) => { return dispatch(getRecentlyInvoicedOrders(value, fromDate, toDate, page, pageSize, sorted)) },//example function
        submitRecentlyInvoicedOrdersCall: (ordersData, invoiceDate) => { return dispatch(submitRecentlyInvoicedOrders(ordersData, invoiceDate)) },
    });
};

function mapStateToProps(state) {
    const { reportsData } = state.invoicingReducer;
    const { total_orders, total_invoices, total_amount } = state.reportReducer;
    return {
        reportsData, total_orders, total_invoices, total_amount
    };
}


const RecentlyInvoicedOrders = connect(mapStateToProps, mapDispatchToProps)(RecentlyInvoicedOrdersPage);
export default RecentlyInvoicedOrders;
